import { Component } from '@angular/core';
import {Token} from "../../auth/models/token";
import {AuthService} from "../../auth/services/auth-service";
import {ToastrService} from "ngx-toastr";
import {ListaTarefa} from "../../juridico/models/lista-tarefa";
import {Dashboard} from "../models/dashboard";
import {DashboardService} from "../../gestao/services/dashboard.service";
import {DashboardAdvogado} from "../models/dashboardAdvogado";
import {ActivatedRoute, Router} from "@angular/router";
import {EmpresaService} from "../../cadastro/services/empresa.service";

@Component({
    selector: 'app-inicial',
    templateUrl: './inicial.component.html',
    styleUrl: './inicial.component.css',
    standalone: false
})
export class InicialComponent {
  token: Token | undefined;
  listaTarefas = new ListaTarefa();
  dashboard = new Dashboard();
  dashboardAdvogado = new DashboardAdvogado();
  assinatura = true;

  constructor(private tokenService: AuthService,
              private dashboardService: DashboardService,
              private toastr: ToastrService,
              private route: ActivatedRoute,
              private empresaService: EmpresaService,
              private router: Router) {
    this.token = this.tokenService.AccessToken;
    this.buscarDashboard();
    this.capturarOrigemDaRota();
    this.checarPagamento();

  }

  private checarPagamento(){
    let empresaId = this.token?.origem ?? 0;
    this.empresaService.checarPagamento(empresaId).subscribe(response =>{
      if(response.sucesso)
        this.assinatura = response.dados;
      else
        this.assinatura = true;
    });
  }

  private buscarDashboard(){

    if(this.token != undefined && this.token.tipoSaas == 1) {
      this.dashboardService.buscarDashboardAdvogado().subscribe(response =>{
        if(response.sucesso){
          this.dashboardAdvogado = response.dados;
        }
      });
    }
    else{
      this.dashboardService.buscarDashboardInicial().subscribe(response =>{
        if(response.sucesso){
          this.dashboard = response.dados;
        }
      });
    }

  }

  private capturarOrigemDaRota() {
    const rotaAtual = this.router.url;

    if(rotaAtual?.toUpperCase().includes("SUCESSO"))
      this.gravarSucessoAssinatura();
    else if(rotaAtual?.toUpperCase().includes("ERRO"))
    {
      this.assinatura = true;
    }

  }

  private gravarSucessoAssinatura(){
    this.toastr.success("Assinatura efetuada com sucesso!");
  }
}
